<template>
  <div class="flex ml8 mr8" :class="['yxtbiz-rank__my-rank' + styleType]">
    <div class="flex">
      <div class="flex align-items-center" :class="{'mr24': styleType === 1 && contentObj.attributeCode, 'mt12': styleType === 1}">
          <yxtf-tooltip
                placement="top"
                open-filter
                class="ellipsis"
                :content="$t('pc_biz_rank_my_rank').d('我的排名')"
              >
          <div class="yxtbiz-rank__my-rank-text">{{
            $t('pc_biz_rank_my_rank').d('我的排名')
          }}</div>
         </yxtf-tooltip>
        <span
          v-if="myRankData.rankResult !== 2"
          class="text-26 yxtbiz-rank__my-rank-order"
          >{{
            myRankData.rankResult === 1 ? titleObj.showTop + '+' : myRankData.rankOrder
          }}</span
        >
        <span v-else class="text-26 yxtbiz-rank__my-rank-order">{{ $t('pc_biz_rank_be_ruled_out').d('未上榜') }}</span>
      </div>
      <!-- 属性对应的值 -->
      <div v-if="contentObj.attributeCode" class="flex align-items-center" :class="{'mt12': styleType === 1}">
         <yxtf-tooltip
                placement="top"
                open-filter
                class="ellipsis"
                :content="contentObj.attributeName"
              >
          <div
            class="text-8c standard-size-12 yxtbiz-rank__my-rank-attribute-name"
            >{{ contentObj.attributeName }}</div
          >
        </yxtf-tooltip>
        <yxtf-tooltip
                placement="top"
                open-filter
                class="ellipsis"
                :content="
                  numberUnit(
                    myRankData.contents[contentObj.attributeCode]
                  )
                "
              >
            <div class="yxtbiz-rank__my-rank-attribute-content standard-size-16 text-59">{{
              numberUnit(
                myRankData.contents[contentObj.attributeCode]
              )
            }}</div>
          </yxtf-tooltip>
      </div>
    </div>
    <div v-if="styleType === 2 && !styleObject.hideHeader && styleObject.hideTitle" class="flex">
      <!-- 榜单名称 -->
      <slot name="title"></slot>
      <!-- 日期选择 -->
      <select-conditions class="ml20" @changeDate="$emit('changeDate', $event)"/>
    </div>
  </div>
</template>
<script>
import { numberUnit } from '../config';
import selectConditions from './selectConditions.vue';

export default {
  components: {
    selectConditions
  },
  props: {
    // 我的排名数据
    myRankData: {
      type: Object,
      default: () => {}
    },
    // 样式类型: 1 一列式、2 两列式
    styleType: {
      type: Number,
      default: 1
    }
  },
  inject: ['contentFun', 'titleFun', 'styleFun'],
  computed: {
    // 显示内容数据
    contentObj() {
      return this.contentFun();
    },
    // 榜单名称数据
    titleObj() {
      return this.titleFun();
    },
    // hideTitle 隐藏标题
    styleObject() {
      return this.styleFun();
    }
  },
  data() {
    return {
      numberUnit
    };
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
